import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrandLogo } from '../../components/BrandMark';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
import { homePath } from '../../utils/clientReview';

/**
 * MOB/Auth/Splash — automatic transition, no CTA.
 * Returning authenticated users go straight to Home; new users start the flow.
 */
export function Splash() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    authenticated,
    onboarded
  } = useSession();
  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (authenticated && onboarded) navigate(homePath(), {
        replace: true
      });else if (authenticated) navigate('/onboarding', {
        replace: true
      });else navigate('/idioma', {
        replace: true
      });
    }, 1400);
    return () => window.clearTimeout(timer);
  }, [authenticated, onboarded, navigate]);
  return <div className="flex min-h-screen w-full flex-col items-center justify-center bg-deep px-3" data-id="element-2408" data-mp="a1ygj144xm2m">
      <BrandLogo width={168} data-id="element-2409" data-mp="2h1w1j3tjavnl" />
      <p className="bee-overline mt-3 text-[9px] font-bold text-gold" data-id="element-2410" data-mp="2m18kvel75klf">
        {t('entry.splash.tag')}
      </p>

      <div className="mt-6 h-[3px] w-[104px] overflow-hidden rounded-pill bg-sand/15" data-id="element-2411" data-mp="2r0lau87d77s8">
        <span className="bee-splash-bar block h-full w-1/3 rounded-pill bg-gold" data-id="element-2412" data-mp="2v1x4cotd0d5p" />
      </div>
      <p className="sr-only" role="status" data-id="element-2413" data-mp="1ybmpl27y3pip">
        {t('entry.splash.loading')}
      </p>
    </div>;
}